var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.43713 8.25C7.12647 8.25 6.87463 8.50184 6.87463 8.8125C6.87463 9.12316 7.12647 9.375 7.43713 9.375H8.56213C8.87279 9.375 9.12463 9.12316 9.12463 8.8125C9.12463 8.50184 8.87279 8.25 8.56213 8.25H7.43713Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8121 8.25C10.5015 8.25 10.2496 8.50184 10.2496 8.8125C10.2496 9.12316 10.5015 9.375 10.8121 9.375H13.0621C13.3728 9.375 13.6246 9.12316 13.6246 8.8125C13.6246 8.50184 13.3728 8.25 13.0621 8.25H10.8121Z",
    fill: "#808080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25005 0.375C0.628725 0.375 0.125046 0.87868 0.125046 1.5V3.7882C0.124772 3.79541 0.124634 3.80265 0.124634 3.80993C0.124634 3.8172 0.124772 3.82445 0.125046 3.83166V10.5C0.125046 11.1213 0.628725 11.625 1.25005 11.625H14.75C15.3714 11.625 15.875 11.1213 15.875 10.5V1.5C15.875 0.878679 15.3714 0.375 14.75 0.375H1.25005ZM1.25005 10.5V4.37243H14.75V10.5H1.25005ZM1.25005 3.24743H14.75V1.5H1.25005V3.24743Z",
    fill: "#808080"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.358c008c.svg";
export { ForwardRef as ReactComponent };